module.exports = __webpack_public_path__ + "static/media/rio-de-janeiro-9.d2016990.jpg";